import classNames from 'classnames';
import { useRef, useState } from 'react';
import { Checkbox } from 'tdesign-react';

import { EyesIcon } from '@/components/icon';
import {
  IPlayer,
  VideoPlayer,
} from '@/material/form-upload/core/player/video/video';

import { MediaViewerProps } from './audio';
import ReviewDialog from './dialog';
import styles from './index.module.less';

const LibraryVideoViewer: React.FC<MediaViewerProps> = (props) => {
  const { checked = false, onCheckedChange, url } = props;

  const [hover, setHover] = useState(false);

  const handleChange = (value: boolean) => {
    onCheckedChange?.(value);
  };

  const videoPlayerRef = useRef<IPlayer>(null);

  const triggerPlay = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    setVisible(true);
  };

  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const mask = (
    <div
      onClick={() => handleChange(!checked)}
      style={{
        color: '#fff',
        height: '100%',
        position: 'absolute',
        width: '100%',
        borderRadius: 6,
      }}
    >
      {
        (hover) || (checked && hover)
          ? <span className={styles.browseIcon} onClick={triggerPlay}>
            <EyesIcon name={'browse'} />
          </span> : null
      }
      {
        hover || checked
          ? <span className={styles.checkboxIcon}>
            <Checkbox checked={checked}></Checkbox>
          </span> : null
      }
    </div>
  );

  return (
    <div>
      <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={classNames(styles.content, styles.videoContent, { [styles.active]: checked })}>
        <div>
          <VideoPlayer
            url={url}
            wrapWidth={136}
            wrapHeight={136}
            hiddenPlayBtn={true}
          />
          <ReviewDialog visible={visible} onClose={onClose}>
            <VideoPlayer
              playRef={videoPlayerRef}
              url={url}
              wrapWidth={800}
              wrapHeight={500}
              controls={true}
              hiddenPlayBtn={true}
              wrapStyle={{ background: 'black' }}
            />
          </ReviewDialog>
          {props.children}
        </div>
        {hover || checked ? <div className={styles.mask}>{mask}</div> : null}
      </div>
    </div>
  );
};

export default LibraryVideoViewer;
